import { ReactElement } from 'react';

import { Building } from '@dreryk/address-common-api';

import { commonTranslationKeys, FormContextValues, ValidationRules } from '@dreryk/react-common';
import { BuildingInput } from '@dreryk/react-components';

const BUILDING_FIELD_MAX_LENGTH = 20;

type BuildingFormBeanPart = { building: Building | null };

const validationRules: ValidationRules<BuildingFormBeanPart> = {
   required: true,
   maxLength: BUILDING_FIELD_MAX_LENGTH,
};

type BuildingFieldProps = Pick<FormContextValues<BuildingFormBeanPart>, 'register'>;

export const BuildingField = (props: BuildingFieldProps): ReactElement => {
   return (
      <BuildingInput
         testId={'building'}
         label={commonTranslationKeys.addressData.houseNumberAbbreviation}
         controller={props.register('building', validationRules)}
      />
   );
};
